import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c2c69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "Flex_Wrapper" }
const _hoisted_3 = { class: "Flex_Child_OneThird" }
const _hoisted_4 = { class: "SearchDetail_Contents" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "返品受領日", -1))
const _hoisted_6 = { class: "SearchDetail_Contents_List SearchDetail_Contents_List" }
const _hoisted_7 = { class: "Flex_Child_OneThird" }
const _hoisted_8 = { class: "SearchDetail_Contents" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取次返品日", -1))
const _hoisted_10 = { class: "SearchDetail_Contents_List SearchDetail_Contents_List" }
const _hoisted_11 = { class: "Flex_Child_OneThird" }
const _hoisted_12 = { class: "SearchDetail_Contents" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "イベント", -1))
const _hoisted_14 = { class: "SearchDetail_Contents_List" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "Flex_Wrapper" }
const _hoisted_17 = { class: "Flex_Child_Quarter" }
const _hoisted_18 = { class: "SearchDetail_Contents" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取次", -1))
const _hoisted_20 = { class: "SearchDetail_Contents_List" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "Flex_Child_Quarter" }
const _hoisted_23 = { class: "SearchDetail_Contents" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品コード", -1))
const _hoisted_25 = { class: "SearchDetail_Contents_List SearchDetail_Contents_List--Wide" }
const _hoisted_26 = { class: "Flex_Child_Quarter" }
const _hoisted_27 = { class: "SearchDetail_Contents" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品区分名", -1))
const _hoisted_29 = { class: "SearchDetail_Contents_List" }
const _hoisted_30 = ["value"]

import { reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import ModalEventList from "@/components/modal/ModalEventList.vue";
import ModalSyosiList from "@/components/modal/ModalSyosiList.vue";
import InputText from "@/components/atoms/Input/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchReturnSlip',
  setup(__props, { expose: __expose }) {

const store = useStore();

//検索項目のリスト取得
//取次(「全件」項目を追加)
const zenken = { toritugiCd: "", torihikisakiCd: "", toritugiMei: "全件" };
const toritugiList = [zenken, ...store.getters["constant/getToritugiList"]];
//商品区分名（種別）
const syubetuList = store.getters["constant/getSyubetuList"];
// イベント
const eventList = store.getters["constant/getEventHenpinDenpyouList"];

//詳細検索項目の格納用
let searchConditions = reactive({
  // APIに渡す引数項目
  fromAcceptedHenpinDate: "",
  toAcceptedHenpinDate: "",
  fromToritugiHenpinDate: "",
  toToritugiHenpinDate: "",
  eventMei: "",
  toritugiCd: "",
  syosiCd: "",
  syouhinKbnMei: "",
  jikoDenpyouNumber: "",
  toritugiDenpyouNumber: "",
  // 画面上の表示のみ
  syosiTitle: "",
});
watch(searchConditions, () => {
  store.commit("search/setReturnSlipState", searchConditions);
});

//モーダル開閉---------------------------
let eventModalVisible = ref(false);
let syosiModalVisible = ref(false);
const showModal = (modalName: string): void => {
  if (modalName === "eventModal") {
    eventModalVisible.value = true;
  }
  if (modalName === "syosiModal") {
    syosiModalVisible.value = true;
  }
};
const closeModal = (modalName: string): void => {
  if (modalName === "eventModal") {
    eventModalVisible.value = false;
  }
  if (modalName === "syosiModal") {
    syosiModalVisible.value = false;
  }
};
const ref_selectEvent = (selectedValue: string): void => {
  searchConditions.eventMei = selectedValue;
};
const ref_selectSyosi = (selectedValue: {
  syosiCd: string;
  title: string;
}): void => {
  searchConditions.syosiCd = selectedValue.syosiCd;
  searchConditions.syosiTitle = selectedValue.title;
};

// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchConditions.fromAcceptedHenpinDate = "";
  searchConditions.toAcceptedHenpinDate = "";
  searchConditions.fromToritugiHenpinDate = "";
  searchConditions.toToritugiHenpinDate = "";
  searchConditions.eventMei = "";
  searchConditions.toritugiCd = "";
  searchConditions.syosiCd = "";
  searchConditions.syouhinKbnMei = "";
  searchConditions.jikoDenpyouNumber = "";
  searchConditions.toritugiDenpyouNumber = "";
  searchConditions.syosiTitle = "";
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(eventModalVisible))
      ? (_openBlock(), _createBlock(ModalEventList, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal('eventModal'))),
          onRef_selectEvent: ref_selectEvent
        }))
      : _createCommentVNode("", true),
    (_unref(syosiModalVisible))
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('syosiModal'))),
          onRef_selectSyosi: ref_selectSyosi
        }))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchConditions).fromAcceptedHenpinDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).fromAcceptedHenpinDate]
              ]),
              _createTextVNode("～"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchConditions).toAcceptedHenpinDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).toAcceptedHenpinDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchConditions).fromToritugiHenpinDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).fromToritugiHenpinDate]
              ]),
              _createTextVNode("～"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchConditions).toToritugiHenpinDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).toToritugiHenpinDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("li", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchConditions).eventMei) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option,
                    key: index
                  }, _toDisplayString(option), 9, _hoisted_15))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).eventMei]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("li", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchConditions).toritugiCd) = $event))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                  return _createElementVNode("option", {
                    value: option.toritugiCd,
                    key: index
                  }, _toDisplayString(option.toritugiMei), 9, _hoisted_21)
                }), 64))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).toritugiCd]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("li", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "InputText_Input SearchDetail_Input_Yellow",
                onDblclick: _cache[8] || (_cache[8] = ($event: any) => (showModal('syosiModal'))),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchConditions).syosiCd) = $event))
              }, null, 544), [
                [_vModelText, _unref(searchConditions).syosiCd]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("li", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchConditions).syouhinKbnMei) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syubetuList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.syubetu,
                    key: index
                  }, _toDisplayString(option.syubetu), 9, _hoisted_30))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).syouhinKbnMei]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})